import { Team__Coyotes } from "../teams/Coyotes";
import { Team__Cerveceros } from "../teams/Cerveceros";
import { Team__FloresMagon } from "../teams/FloresMagon";
import { Team__Apaches } from "../teams/Apaches";
import { Team__Nogaleros } from "../teams/Nogaleros";
import { Team__FoxImpresos } from "../teams/FoxImpresos";

const Coyotes = {
  team: Team__Coyotes,
  playingPlayers: [],

  goals: 47,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

const FloresMagon = {
  team: Team__FloresMagon,
  playingPlayers: [],

  goals: 49,
  penaltyGoals: 0,
  isWinner: false,
};

const Apaches = {
  team: Team__Apaches,
  playingPlayers: [],

  goals: 52,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 52,
  penaltyGoals: 0,
  isWinner: false,
};

const FoxImpresos = {
  team: Team__FoxImpresos,
  playingPlayers: [],

  goals: 62,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada1 = {
  jornadaPosition: 1,
  matches: [
    {
      team1: Coyotes,
      team2: Cerveceros,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "17:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: FloresMagon,
      team2: Apaches,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "18:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Nogaleros,
      team2: FoxImpresos,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "19:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
